import { render, staticRenderFns } from "./CambioMSI.vue?vue&type=template&id=1e67efac"
import script from "./CambioMSI.vue?vue&type=script&lang=js"
export * from "./CambioMSI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports